// ============================================================================
// COMPANY INFO — the ONLY file you need to edit.
// Every legal page reads from here, so filling this in updates all of them.
// Razorpay's activation review checks that these details are real and match
// the entity on the merchant account. Replace every [SQUARE BRACKET] value.
// ============================================================================

const companyInfo = {
  // ── Legal entity (must match the Razorpay merchant account) ──
  legalName: '[COMPANY LEGAL NAME PVT LTD]',
  brandName: 'LeaDBoat',
  entityType: '[Private Limited Company / LLP / Partnership / Proprietorship]',
  cin: '[CIN NUMBER]',
  gstin: '[GSTIN]',

  // ── Registered address ──
  address: {
    line1: '[BUILDING / STREET]',
    line2: '[AREA / LANDMARK]',
    city: '[CITY]',
    state: '[STATE]',
    pincode: '[PINCODE]',
    country: 'India',
  },

  // ── Support contact (must be reachable — Razorpay may test it) ──
  supportEmail: '[support@yourdomain.com]',
  supportPhone: '[+91 XXXXX XXXXX]',
  supportHours: 'Monday to Saturday, 10:00 AM to 7:00 PM IST',

  // ── Web ──
  website: '[https://yourdomain.com]',

  // ── Effective date shown on every policy page ──
  effectiveDate: '[DD Month YYYY]',

  // ── Pricing shown on the public /pricing page ──
  // Keep this in sync with billing_config.seat_monthly_price in the database.
  pricing: {
    seatMonthlyPrice: 410,
    currency: 'INR',
    currencySymbol: '₹',
    // Duration discounts — keep in sync with the duration_options table.
    durations: [
      { label: '1 Month', months: 1, discountPct: 0 },
      { label: '3 Months', months: 3, discountPct: 0 },
      { label: '6 Months', months: 6, discountPct: 0 },
      { label: '1 Year', months: 12, discountPct: 0 },
    ],
  },

  // ── Refund policy decision points — change these to your actual terms ──
  refund: {
    // Days within which a first-time purchase can be refunded. 0 = no refunds.
    windowDays: 7,
    // Working days taken to process an approved refund back to source.
    processingDays: 7,
  },
};

// Formatted single-line address, used across the legal pages.
export const formattedAddress = [
  companyInfo.address.line1,
  companyInfo.address.line2,
  companyInfo.address.city,
  companyInfo.address.state,
  companyInfo.address.pincode,
  companyInfo.address.country,
].filter(Boolean).join(', ');

export default companyInfo;
